import React from 'react';
import { Badge } from 'antd';
import { MobileCard, MobileRow, MobileLabel, MobileValue } from './Styles';
import type { PaymentItem } from './types';
import { TABLE_COLUMNS, STATUS_LABELS } from './constants';

type PaymentSectionType = 'pending' | 'cleared' | 'upcoming';

interface MobilePaymentCardProps {
  payment: PaymentItem;
  type: PaymentSectionType;
}

const statusColorMap: Record<PaymentSectionType, string> = {
  pending: 'orange',
  cleared: 'green',
  upcoming: 'blue',
};

const statusLabelMap: Record<PaymentSectionType, string> = {
  pending: STATUS_LABELS.PENDING,
  cleared: STATUS_LABELS.CLEARED,
  upcoming: STATUS_LABELS.SCHEDULED,
};

const formatAmount = (amount: number | string): string =>
  typeof amount === 'number' ? `$${amount}` : `$${amount}`;

const MobilePaymentCard: React.FC<MobilePaymentCardProps> = ({ payment, type }) => {
  const dateLabel = type === 'cleared' ? TABLE_COLUMNS.PAYMENT_DATE : TABLE_COLUMNS.DUE_DATE;
  const dateValue = type === 'cleared' ? payment.paymentDate : payment.dueDate;

  return (
    <MobileCard size="small">
      <MobileRow>
        <MobileLabel>{TABLE_COLUMNS.MERCHANT}</MobileLabel>
        <MobileValue>{payment.merchant}</MobileValue>
      </MobileRow>
      <MobileRow>
        <MobileLabel>{TABLE_COLUMNS.AMOUNT}</MobileLabel>
        <MobileValue>{formatAmount(payment.amount)}</MobileValue>
      </MobileRow>
      <MobileRow>
        <MobileLabel>{dateLabel}</MobileLabel>
        <MobileValue>{dateValue ?? '—'}</MobileValue>
      </MobileRow>
      <MobileRow>
        <MobileLabel>{TABLE_COLUMNS.STATUS}</MobileLabel>
        <Badge color={statusColorMap[type]} text={statusLabelMap[type]} />
      </MobileRow>
    </MobileCard>
  );
};

export default React.memo(MobilePaymentCard);
